<template>
  <div class="login-warp">
    <div class="logo">
      <img src="../../assets/imgs/logo.png" alt="" />
    </div>
    <div v-if="loginMode === 'phone'" class="login-row">
      <div class="area" @click="isAreaView = true">
        <span>+{{ areaCode }}</span>
        <div class="area-down"></div>
      </div>
      <input type="number" v-model="phone" :placeholder="i18n.phone_number" />
    </div>
    <div v-else class="login-row">
      <input type="email" v-model="email" :placeholder="i18n.email" />
    </div>
    <!-- <div class="login-row">
      <input type="number" v-model="code" :placeholder="i18n.captcha_code" />
      <div class="login-code" @click="onCaptcha">
        <img :src="captchaUrl" />
      </div>
    </div> -->
    <div class="login-info">
      <span
        >{{ i18n.agree }}
        <span class="readme" @click="onReadMe(1)">{{ i18n.readme }}</span>
        {{ i18n.and }}
        <span class="readme" @click="onReadMe(2)">{{ i18n.privacy }}</span>
      </span>
    </div>
    <div class="btn" @click="beforeLogin">{{ i18n.login }}</div>
    <div
      v-if="loginMode === 'email'"
      class="textbtn"
      @click="switchLoginMode('phone')"
    >
      {{ i18n.phonelogin }}
    </div>
    <div v-else class="textbtn" @click="switchLoginMode('email')">
      {{ i18n.emaillogin }}
    </div>
    <div class="login-foot">
      <div class="login-foot-tips">
        <span>{{ i18n.sign_in_with }}</span>
      </div>
      <div class="login-foot-imgs">
        <login-facebook @success="loadUser">
          <img src="../../assets/imgs/icon_facebook.png" alt="" />
        </login-facebook>
        <login-google @success="loadUser">
          <div id="buttonDiv"></div>
          <!-- <img src="../../assets/imgs/icon_google.png" alt=""> -->
        </login-google>
      </div>
    </div>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
    <login-code
      v-if="isLoginCode"
      @submit="onLogin"
      @again="onBack"
      @back="onBack"
    ></login-code>
  </div>
</template>

<script>
import md5 from "js-md5"
import { SelectArea } from "../../components/select"
import { baseURL } from "../../utils/http"
import { generateUUID } from "../../utils/index"
import {
  USER_CAPTCHA,
  LOGIN_CODE,
  LOGIN_EMAILCODE,
  SEND_CODE,
  SEND_EMAILCODE,
  USER_INFO
} from "../../apis/user"
import { LoginCode, LoginFacebook, LoginGoogle } from "../../components/login"
import { mapState } from "vuex"
import googleRecaptchaMixin from "@/mixins/googleRecaptcha.js"

export default {
  mixins: [googleRecaptchaMixin],
  components: {
    SelectArea,
    LoginCode,
    LoginFacebook,
    LoginGoogle
  },
  computed: {
    ...mapState(["user", "browser"]),
    i18n() {
      return this.$t("login")
    },
    i18nMsg() {
      return this.$t("msg")
    }
  },
  watch: {
    user(val, oldVal) {
      if (val && !oldVal) {
        this.$router.push("/")
      }
    }
  },
  data() {
    return {
      isAreaView: false,
      areaCode: "49",
      phone: "",
      email: "",
      isLoginCode: false,
      loginMode: "phone",
      code: "",
      uuid: "",
      captchaUrl: ""
    }
  },
  methods: {
    onReadMe(num) {
      if (num === 1) {
        window.open(process.env.VUE_APP_PACT)
      } else {
        window.open(process.env.VUE_APP_PRIVACY)
      }
    },
    onSelct(val) {
      this.areaCode = val
    },
    onCaptcha() {
      this.code = ""
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    beforeLogin() {
      console.log("方式", this.loginMode)
      this.$loading(true)
      this.loadGoogleRecaptchaScript((token) => {
        if (this.loginMode === "phone") {
          this.onSendCode(token)
        } else {
          console.log("邮箱登录")
          this.onSendEmailCode(token)
        }
      })
    },
    onLogin(code) {
      let url = LOGIN_CODE
      let datas = {
        mobile: this.areaCode + this.phone,
        verifyCode: code
      }
      if (this.loginMode === "email") {
        url = LOGIN_EMAILCODE
        datas = {
          email: this.email,
          verifyCode: code
        }
      }
      this.$loading(true)
      this.$post(
        url,
        datas,
        (res) => {
          console.log(res)
          this.$loading(false)
          if (res.token) {
            this.$store.commit("token", res.token)
            this.loadUser()
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (err) => {
          console.log(err)
          this.$loading(false)
        }
      )
    },
    onSendCode(token) {
      if (!this.phone && this.loginMode === "phone") {
        this.$toast(this.i18nMsg.msg_fail_phone)
        return
      }
      var timestamp = Math.floor(Date.now() / 1000)
      var sign = md5(timestamp.toString().replaceAll("0", "8") + "GZzbjkj")
      let url = `${SEND_CODE}?mobile=${this.areaCode + this.phone}&timestamp=${timestamp}&sign=${sign}`
      this.$post(
        url,
        {
          reCAPTCHA: {
            token: token,
            platform: 'web'
          }
        },
        (res) => {
          console.log(res)
          this.$loading(false)
          this.isLoginCode = true
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    },
    onSendEmailCode(token) {
      if (!this.email) {
        this.$toast(this.i18nMsg.msg_fail_email)
        return
      }
      var timestamp = Math.floor(Date.now() / 1000)
      var sign = md5(timestamp.toString().replaceAll("0", "8") + "GZzbjkj")
      let url = `${SEND_EMAILCODE}?email=${this.email}&timestamp=${timestamp}&sign=${sign}`
      this.$loading(true)
      this.$post(
        url,
        {
          reCAPTCHA: {
            token: token,
            platform: 'web'
          }
        },
        (res) => {
          console.log(res)
          this.$loading(false)
          this.isLoginCode = true
        },
        (err) => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    },
    onBack() {
      this.isLoginCode = false
    },
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            this.$toast(this.i18n.msg_success_login)
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_user
            })
              .then(() => {
                this.loadUser()
              })
              .catch(() => {
                this.$store.commit("token", null)
              })
          }
        },
        (err) => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          }).then(() => {
            this.$store.commit("token", null)
          })
        }
      )
    },
    switchLoginMode(type) {
      this.onCaptcha()
      this.loginMode = type
    }
  },
  created() {
    if (this.browser === "wechat") {
      this.$router.push("/login_wechat")
    } else if (this.browser === "alipay") {
      this.$router.push("/login_alipay")
    }
  },
  mounted() {
    // this.onCaptcha()
  }
}
</script>

<style lang="less">
.login-warp {
  height: 100vh;
  background-color: #fff;
  .logo {
    padding: 100px 0 40px 0;
    img {
      display: block;
      margin: 0 auto;
      width: 250px;
    }
  }
  .login-row {
    margin: 36px 96px;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 4px solid #000;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }
    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: black transparent transparent;
    }
    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );
      img {
        width: 180px;
        height: 60px;
      }
    }
  }
  .btn {
    margin: 60px 96px 0;
  }
  .login-foot {
    position: fixed;
    left: 96px;
    right: 96px;
    bottom: 48px;
    &-tips {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      span {
        z-index: 999;
        background: #fff;
        padding: 28px;
      }
      &::after {
        position: absolute;
        content: " ";
        height: 1px;
        width: 100%;
        background-color: #000;
        z-index: 99;
      }
    }
    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #e4e7ed;
        margin: 0 34px;
      }
    }
  }
  .login-info {
    font-size: 24px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 33px;
    font-family: "Montserrat-Regular";
    display: flex;
    justify-content: flex-start;
    padding: 0 96px;
  }
  .login-info .readme {
    font-weight: 500;
    color: rgba(52, 125, 255, 1);
    margin-left: 10px;
    display: inline;
  }
}
</style>
